$(function () {
  const el = document.querySelector('.js-scroll-top')

  if (!el) return;

  el.addEventListener('click', e => {
    e.preventDefault()
    $('html, body').animate({
      scrollTop: 0
    }, 1000);
  })

  let height = window.innerHeight

  window.addEventListener('resize', () => {
    height = window.innerHeight
  })

  window.addEventListener('scroll', () => {
    if (window.pageYOffset > height) {
      el.classList.add('active')
    } else {
      el.classList.remove('active')
    }
  })
})